<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <DashboardHeader />
    <v-row>
      <v-col
        :cols="mobile() ? 11 : 4"
        class="d-flex justify-end mx-auto"
      >
        <SearchBarGlobal
          :space-id="spaceId"
        />
      </v-col>
    </v-row>
    <ListGridViewMode v-if="role == 'booster' || role == 'space_admin'" @toggleView="toggleView" :class="mobile() ? '' : 'mt-n16'" />
    <v-row
      v-if="hubs.length == 0 && !loadingData && mobile()"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <EmptyPage
          :page-title="$t('emptyHubsDashboardTitle')"
          :page-text="$t('emptyDashboardText')"
          page-image="image2"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="hubs.length == 0 && !loadingData && !mobile()"
      align="center"
      class="mt-16"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <EmptyPage
          :page-title="$t('createContentTemplateTitleHub')"
          :page-text="$t('createContentTemplateTextHub')"
          page-image="image2"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="hubs.length > 0 && !loadingData"
      class="mx-auto"
    >
      <v-col
        align="center"
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? '' : 'mx-auto px-0'"
      >
        <v-row>
          <v-col
            cols="12"
            class="d-flex justify-start align-center"
          >
            <p class="text-h5 mb-0 font-weight-bold">
              {{ $t('hubs') }}
            </p>
          </v-col>
        </v-row>
        <v-row v-if="view == 'grid-view'" align="center">
          <v-col
            v-for="item in hubs"
            :key="item.id"
            cols="12"
            sm="6"
            xl="4"
          >
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                height="280"
                data-testid="hub-card"
                rounded="xxl" 
                class="mx-auto rounded-xll"
                :ripple="false"
                :class="`elevation-${hover? 8 : 2 } ${hover? 'v-card--shadow': 'v-card--flat'}`"
                :to="'/hub/'+item.id"
              >
                <v-responsive class="rounded-b-0">
                  <v-img
                    class="rounded-t-xl"
                    :src="(item.attributes.image) ? item.attributes.image : require('../../assets/background-hub.jpg')"
                    height="120px"
                  >
                    <v-card-text class="py-5">
                      <v-row
                        no-gutters
                        class="mx-auto"
                      >
                        <v-col
                          class="d-flex align-start ml-2"
                          cols="12"
                          sm="12"
                          md="12"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-chip
                                small
                                data-testid="sharing-setting-chip"
                                color="darktext"
                                text-color="white"
                                filter-icon="mdi-equalizer-outline"
                                class="mr-4"
                                v-on="on"
                              >
                                <v-icon
                                  size="14"
                                  class="pr-1"
                                >
                                  mdi-share-variant
                                </v-icon>
                                <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestricted') }}</span>
                                <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpen') }}</span>
                              </v-chip>
                            </template>
                            <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestrictedHubTooltip') }}</span>
                            <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpenHubTooltip') }}</span>
                          </v-tooltip>
                          <v-chip
                            small
                            color="accent"
                          >
                            <span class="text-uppercase">{{ $t('hub') }}</span>
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-img>
                </v-responsive>
                <v-card-text class="pa-0">
                  <v-row no-gutters>
                    <v-col
                      cols="11"
                      sm="11"
                      md="11"
                      class="py-0"
                    >
                      <v-card-title
                        class="text-left no-break darktext--text"
                        style="line-height:inherit"
                      >
                        <v-clamp
                          autoresize
                          :max-lines="1"
                        >
                          {{ item.attributes.title }}
                        </v-clamp>
                      </v-card-title>
                    </v-col>
                    <v-col
                      v-if="item.attributes.role == 'booster'"
                      class="d-flex justify-end"
                      cols="1"
                      sm="1"
                      md="1"
                    >
                      <v-card-actions class="pa-2">
                        <v-menu class="float-right">
                          <template v-slot:activator="{  on: { click }, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on:click.stop.prevent="click"
                            >
                              <v-icon
                                large
                                class="darktext--text"
                                data-testid="threedots-icon"
                              >
                                mdi-dots-vertical
                              </v-icon>
                            </v-btn>
                          </template>
                          <v-list data-testid="menu-list-actions">
                            <v-list-item 
                              router 
                              data-testid="analytics-icon-hub"
                              @click.stop="openPeopleInHub(item.id)"
                            >
                              <v-list-item-title> {{ $t('analytics') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              data-testid="edit-hub"
                              router 
                              @click="openHubSettingsDialog(item)"
                            >
                              <v-list-item-title> {{ $t('settings') }} </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              data-testid="remove-hub"
                              router 
                              @click.stop="
                                selectedHubForDeletion = item.id,
                                dialogVisibleRemoveHub = true, 
                                confirmationDialogTitle = $t('confirmationDialogTitleRemoveHub'), 
                                confirmationDialogText = $t('confirmationDialogTextRemoveHub'), 
                                confirmationDialogSubmitBtn = $t('delete')
                                confirmationDialogCancelBtn = $t('no')"
                            >
                              <v-list-item-title> {{ $t('deleteHub') }} </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-card-actions>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      class="py-0"
                    >
                      <v-card-subtitle class="text-left text-body-1 greytext--text no-break darktext--text py-0">
                        <v-clamp
                          autoresize
                          :max-lines="3"
                        >
                          {{ item.attributes.description }}
                        </v-clamp>
                      </v-card-subtitle>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <v-card v-if="view == 'list-view'" elevation="0" class="pa-3 rounded-xxl base-background">
          <v-row align="center" no-gutters>
            <v-col cols="12">
              <v-card-text class="pa-1">
                <v-row no-gutters>
                  <v-col cols="11" sm="6" class="d-flex align-center">
                    <span class="text-body-1 font-weight-bold">{{ $t('title') }}</span>
                  </v-col>
                  <v-col cols="3" class="align-center d-none d-sm-flex">
                    <span class="text-body-1 font-weight-bold mx-auto">{{ $t('status') }}</span>
                  </v-col>
                  <v-col cols="2" class="align-center d-none d-sm-flex">
                    <span class="text-body-1 font-weight-bold mx-auto">{{ $t('analytics') }}</span>
                  </v-col>
                  <v-col cols="1" class="d-flex justify-end">
                    <span class="text-body-1 font-weight-bold">{{ $t('more') }}   </span>        
                  </v-col>
                </v-row>
              </v-card-text>
            </v-col>
            <v-col cols="12" v-for="(item, index) in hubs" :key="item.id">
              <v-card :rounded="false" class="pa-1 elevation-0 base-background" :to="'/hub/'+item.id">
                <v-row no-gutters class="row-pointer">
                  <v-col cols="11" sm="6" class="d-flex align-center">
                    <v-img class="rounded-xl" :src="(item.attributes.image) ? item.attributes.image : require('../../assets/background-hub.jpg')" max-width="80" height="52"></v-img>
                    <v-card-title class="text-left no-break darktext--text text-body-1">
                      <v-clamp
                        autoresize
                        :max-lines="1"
                      >
                        {{ item.attributes.title }}
                      </v-clamp>
                    </v-card-title>
                  </v-col>
                  <v-col cols="3" class="align-center d-none d-sm-flex">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-chip
                          small
                          data-testid="sharing-setting-chip"
                          color="darktext"
                          text-color="white"
                          filter-icon="mdi-equalizer-outline"
                          v-on="on"
                          class="mx-auto"
                        >
                          <v-icon
                            size="14"
                            class="pr-1"
                          >
                            mdi-share-variant
                          </v-icon>
                          <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestricted') }}</span>
                          <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpen') }}</span>
                        </v-chip>
                      </template>
                      <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestrictedHubTooltip') }}</span>
                      <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpenHubTooltip') }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="2" class="align-center d-none d-sm-flex">
                    <v-tooltip
                      bottom
                      data-testid="analytics-icon"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="d-flex justify-center mx-auto"
                          v-bind="attrs"
                          icon
                          @click.stop.prevent="openPeopleInHub(item.id)"
                          v-on="on"
                        >
                          <v-icon
                            size="22px"
                            class="darktext--text"
                          >
                            mdi-equalizer-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('analyticsInHubTooltip') }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col v-if="item.attributes.role == 'booster'" cols="1" class="d-flex justify-end">
                    <v-card-actions class="pa-1">
                      <v-menu class="float-right">
                        <template v-slot:activator="{  on: { click }, attrs }">
                          <v-btn
                            icon
                            v-bind="attrs"
                            v-on:click.stop.prevent="click"
                          >
                            <v-icon
                              large
                              class="darktext--text"
                              data-testid="threedots-icon"
                            >
                              mdi-dots-vertical
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list data-testid="menu-list-actions">
                          <v-list-item 
                            router 
                            data-testid="analytics-icon-hub"
                            @click.stop="openPeopleInHub(item.id)"
                          >
                            <v-list-item-title> {{ $t('analytics') }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            data-testid="edit-hub"
                            router 
                            @click.stop="openHubSettingsDialog(item)"
                          >
                            <v-list-item-title> {{ $t('settings') }} </v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            data-testid="remove-hub"
                            router 
                            @click.stop="
                              selectedHubForDeletion = item.id,
                              dialogVisibleRemoveHub = true, 
                              confirmationDialogTitle = $t('confirmationDialogTitleRemoveHub'), 
                              confirmationDialogText = $t('confirmationDialogTextRemoveHub'), 
                              confirmationDialogSubmitBtn = $t('delete')
                              confirmationDialogCancelBtn = $t('no')"
                          >
                            <v-list-item-title> {{ $t('deleteHub') }} </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-card-actions>           
                  </v-col>
                </v-row>
              </v-card>
              <v-divider v-if="index < hubs.length - 1"></v-divider>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-fab-transition v-if="!mobile()">
      <v-tooltip
        left
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="accent"
            fixed
            right
            bottom
            fab
            large
            @click.stop="
              dialogVisibleCreateContentTemplate = true "
            v-on="on"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('createContent') }}</span>
      </v-tooltip>
    </v-fab-transition>

        <ConfirmationDialogWithOutSubmitBtn
      v-if="showConfirmationDialog"
      ref="showConfirmationDialog"
      :visible="showConfirmationDialog"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-additonal-text="confirmationDialogAdditonalText"
      @close="showConfirmationDialog = false"
    />
    <ConfirmationDialog
      v-if="dialogVisibleRemoveHub"
      ref="confirmationDialogRemoveHub"
      :visible="dialogVisibleRemoveHub"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog-delete-hub"
      @close="dialogVisibleRemoveHub = false"
      @proceedSubmit="removeHub(selectedHubForDeletion)"
    />
    <Pagination
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="hubsInfo.total"
      :page-number="hubsInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
    />

    <CreateContentTemplateDialog 
      v-if="dialogVisibleCreateContentTemplate"
      ref="confirmationDialogRemoveHub"
      :visible="dialogVisibleCreateContentTemplate" 
      data-testid="create-content-template-dialog" 
      @close="dialogVisibleCreateContentTemplate = false"
      @proceedSubmit="createContentMsg"
    />

    <EditHub
      v-if="selectedHubItem.attributes && selectedHubItem.attributes.role == 'booster' && visibleDialogHubSettingsDialog && !mobile()"
      :visible="visibleDialogHubSettingsDialog"
      :hub-id="selectedHubItem.id"
      :hub-title="selectedHubItem.attributes.title"
      :hub-description="selectedHubItem.attributes.description"
      :hub-image-u-r-l="selectedHubItem.attributes.image"
      :hub-image-path="null"
      :hub-sharing-settings="selectedHubItem.relationships['sharing-setting'].data.id"
      :hub-auto-share="selectedHubItem.attributes.sync_with_space_members"
      :hub-tags="selectedHubItem.attributes.tags"
      :auto-share-with-activities="selectedHubItem.attributes.auto_share_with_activities"
      @close="visibleDialogHubSettingsDialog= false"
      @proceedSubmit="updateHub"
    />
  </nav>
</template>

<script>
import i18n from '../../plugins/i18n'
import { getAllHubs, updateHub } from '../../api/hubApi'
import Pagination from '../../components/Pagination'
import EmptyPage from '../../components/EmptyPage'
import VClamp from 'vue-clamp';
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import CreateContentTemplateDialog from '../../components/CreateContentTemplateDialog'
import EditHub from '../../views/hubs/EditHub'
import DashboardHeader from '../../components/DashboardHeader'
import SearchBarGlobal from '../../components/SearchBarGlobal'
import ListGridViewMode from '../../components/ListGridViewMode.vue'
import ConfirmationDialogWithOutSubmitBtn from '../../components/ConfirmationDialogWithOutSubmitBtn'

export default {
    components: {
        Pagination,
        EmptyPage,
        VClamp,
        AlertMessages,
        ConfirmationDialog,
        CreateContentTemplateDialog,
        EditHub,
        DashboardHeader,
        SearchBarGlobal,
        ListGridViewMode,
        ConfirmationDialogWithOutSubmitBtn
    },
    mixins: [repeatedMethodsMixin],

    data(){
        return{
            hubs: [],
            hubsInfo: {
                  currentPage: 1,
                    total: 1,
            },
            permissions: [],
            spaceId: window.$cookies.get('space_id'),
            alertMsg:'',
            alertType:'',
            alertValue:false,
            pageNumber: 1,
            size: 12,
            link: {title: '', route: '/hub/create'},
            loadingData: false,
            selectedHubForDeletion: '',
            dialogVisibleRemoveHub: false,
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            dialogVisibleCreateContentTemplate:false,
            selectedHubItem: {},
            visibleDialogHubSettingsDialog: false,
            view: window.$cookies && window.$cookies.isKey('viewMode') ?  window.$cookies.get('viewMode') : 'grid-view',
            role: localStorage.space ? JSON.parse(localStorage.space).role : '',
            showConfirmationDialog:false,
            confirmationDialogAdditonalText : '',
            storeProducts:[]

        }
    },
    async created(){
        this.loadingData = true
        await this.fetchHubs()
        this.loadingData = false
    },
    computed: {
    },
    methods:{
        handlePageChange(value){
            this.hubsInfo.currentPage = value
            this.pageNumber = value
            this.fetchHubs()
        },
        showhubPage(){
            this.$router.push({path: '/all-hubs'})
        },
        showActivityPage(){
            this.$router.push({path: '/all-activities'}) 
        },
        seeAll(){
            this.$router.push({path: '/dashboard'}) 
        },
        openPeopleInHub(hubId){
            this.$router.push({path: '/hub/' + hubId + '/overview'})
        },
        createHub(){
          this.$router.push({path: '/hub/create'})
        },
        openCreateContentDialog(){
          this.dialogVisibleCreateContentTemplate = true
        },
        async fetchHubs(){
            try {
                const response = await getAllHubs(this.spaceId, this.pageNumber, this.size)
                if(response.status){
                    if(response.status == 200) {
                        this.hubs = response.data.data
                        window.scrollTo(0,0)
                        if(response.data.meta.page){
                            this.hubsInfo = response.data.meta.page
                        }
                        
                    }
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        this.$router.push({name: 'PageNotFound'})
                    }
                    else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async removeHub(id){
            this.dialogVisibleRemoveHub = false
            try{
                let data = {
                    data: {
                        type: "hubs",
                        id: id,
                        attributes: {
                            deleted_at: this.currentDate()
                        },
                        relationships: {
                            space: {
                                data: {
                                    type: "spaces",
                                    id: this.spaceId
                                }
                            },
                        }
                    }
                }
                const response = await updateHub(id, data)
                if(response.status == 200) {
                  this.confirmationDialogAdditonalText =''
                    await this.fetchHubs()
                    this.alertValue = true
                    this.alertType = 'success'
                    this.alertMsg =  i18n.t('removeHubSuccess')
                }
            } catch (e) {
                
               if(e.response){
                   if (e.response.status == 403 && e.response.data.errors[0].detail == "It is not allowed to delete a hub used in a product.") {
                      this.storeProducts = e.response.data.errors[0].meta.store_products;
                      this.confirmationDialogAdditonalText =''
                      this.showConfirmationDialogCanNotBeDeleted()
                  } else {
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                  }
                }
            }
        },
            showConfirmationDialogCanNotBeDeleted(){
           this.storeProducts.forEach(item => {
              this.confirmationDialogAdditonalText = this.confirmationDialogAdditonalText + '<p class="ml-5 mb-0 text-truncate">  -  ' + item + '</p>';
            });
          this.showConfirmationDialog= true
          this.confirmationDialogTitle= i18n.t('confirmationDialogTitleCanNotBeDeleted')
          this.confirmationDialogText= i18n.t('confirmationDialogTextCanNotBeDeleted')
        },
        createContentMsg(msg, type){
            this.alertType= type
            this.alertMsg = msg
            this.alertValue = true
            this.dialogVisibleCreateContentTemplate = false
        },
        openHubSettingsDialog(item){
            this.selectedHubItem=item
            this.visibleDialogHubSettingsDialog = true
        },
        async updateHub(msg, type){
            this.alertType= type
            this.alertMsg = msg
            this.alertValue = true
            await this.fetchHubs()
        },
        toggleView(view){
          this.view = view
        }
    }
}

</script>